import { styled, css } from "@mui/material";

import { H2WithEmphasisMixin } from "@baseComponents/css";
import { getColor } from "@hooks/useColors";
import { cssPropertiesToString } from "utils";

export const ValuesSectionMainContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;

    ${theme.breakpoints.up("mobile")} {
      gap: 16px;
      padding: 0 16px 0 8px;
    }

    ${theme.breakpoints.up("tablet")} {
      gap: 24px;
      padding: 0 64px 0 20px;
    }

    ${theme.breakpoints.up("desktop")} {
      gap: 40px;
      padding: 0 55px 0 30px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      padding: 0 110px 0 90px;
    }
  `,
);

export const InnerContainer = styled("div")(
  ({ theme }) => css`
    display: flex;

    ${theme.breakpoints.up("mobile")} {
      gap: 0px;
    }

    ${theme.breakpoints.up("tablet")} {
      gap: 48px;
    }

    ${theme.breakpoints.up("desktop")} {
      gap: 80px;
    }
  `,
);

export const AnimationContainer = styled("div")(
  ({ theme }) => css`
    flex-shrink: 0;

    ${theme.breakpoints.up("mobile")} {
      width: 0px;
    }

    ${theme.breakpoints.up("tablet")} {
      width: 256px;
    }

    ${theme.breakpoints.up("desktop")} {
      width: 397px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      width: 550px;
    }
  `,
);

export const ValuesDescriptionContainer = styled("div")(
  ({ theme }) => css`
    ${theme.breakpoints.up("mobile")} {
      padding: 24px 0;
    }

    ${theme.breakpoints.up("tablet")} {
      padding: 80px 0;
    }

    ${H2WithEmphasisMixin(theme)}

    p {
      color: ${getColor(c => c.tokens.text["sub-600"], theme)};

      ${theme.breakpoints.up("mobile")} {
        margin-bottom: 48px;
        ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
      }

      ${theme.breakpoints.up("tablet")} {
        margin-bottom: 72px;
      }

      ${theme.breakpoints.up("desktop")} {
        ${cssPropertiesToString(theme.typography.paragraph_xlarge_medium)}
        margin-bottom: 232px;
      }
    }

    p:last-of-type {
      margin-bottom: 0;
    }
  `,
);
